export default () => import(/* webpackChunkName: 'coffee/activities/new-user-region/home' */ './Home');
